import BonaEditor from './src/bonaeditor.js';
import './src/config';
import './src/editors-manager';
import './src/extensions-manager';
import './src/toolbars-manager';

export default BonaEditor;